import { Borrower } from './borrower.model';
import { Injectable } from '@angular/core';
import { ApiHttpClient } from 'app/http/clients/api';

export interface BorrowerCreateProps {
    id?: number;
    workflow_assignments?: any[];
}

@Injectable()
export class BorrowerFactory {

    constructor(private http: ApiHttpClient) {}

    create(props: BorrowerCreateProps): Borrower {
        const borrower = new Borrower(this.http, props);
        if (props.workflow_assignments) {
            borrower.workflowAssignments = props.workflow_assignments;
            delete props.workflow_assignments;
        }
        return borrower;
    }
}
